import { ChangeEvent, ComponentPropsWithRef, FocusEvent } from 'react';
import { Controller } from 'react-hook-form';

import { InputTextArea } from '../input/input-textarea';

type InputTextAreaControllerProps = Omit<
  ComponentPropsWithRef<typeof InputTextArea>,
  'name' | 'defaultValue' | 'onChange' | 'onBlur'
> & {
  name: string;
  defaultValue?: string;
  onChange?: (value: string, e: ChangeEvent<HTMLElement>) => void;
  onBlur?: (value: string, e: FocusEvent<HTMLElement>) => void;
};

export function InputTextAreaController(props: InputTextAreaControllerProps) {
  const { defaultValue, onChange, onBlur, ...defaultProps } = props;

  return (
    <Controller
      render={({
        field: {
          onChange: onControllerChange,
          onBlur: onControllerBlur,
          value,
        },
        fieldState: { error },
      }) => (
        <InputTextArea
          {...defaultProps}
          onChange={(val, e) => {
            onControllerChange(val);

            onChange?.(val, e);
          }}
          onBlur={(val, e) => {
            onControllerChange(val);

            onControllerBlur();

            onBlur?.(val, e);
          }}
          value={value ?? ''}
          error={error?.message}
        />
      )}
      name={props.name}
      defaultValue={defaultValue ?? ''}
    />
  );
}
